<template>
  <v-container fluid class="lead-page pa-4">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="onLeadCreated"
    />

   
    
    <div class="lead-route-content">
      <router-view />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
const Create = () => import("./components/Create");

export default {
  name: "lead",

  components: {
    Create,
  },

  data() {
    return {
      createDialog: false,
    };
  },

  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
  },

  created() {
    document.title = "smplsale - Lead";
  },

  methods: {
    goHome() {
      if (this.$route.path !== "/lead") {
        this.$router.push({ path: "/lead" });
      }
    },

    add() {
      this.createDialog = true;
    },

    onLeadCreated() {
      this.createDialog = false;
      this.$events.emit("leadListEvent");

      if (this.$route.path !== "/lead/list") {
        this.$router.push({ path: "/lead/list" });
      }
    },
  },
};
</script>

<style scoped>
.lead-page {
  background: #f8fafc;
  min-height: 100%;
}

.lead-top-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 16px;
}

.lead-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.lead-title-wrap {
  display: flex;
  align-items: center;
}

.lead-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.lead-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.lead-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lead-route-content {
  padding: 0;
}

@media (max-width: 600px) {
  .lead-page {
    padding: 10px !important;
  }

  .lead-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .lead-actions .v-btn {
    width: 100%;
  }
}
</style>
